import PropTypes from "prop-types";
import { FaTimes } from "react-icons/fa";

import styles from "./PopupButton.module.css";

const PopupExitButton = ({ keyValue, onClick }) => {
  return (
    <button key={keyValue} className={styles.ExitButton} onClick={onClick}>
      <FaTimes />
    </button>
  );
};

PopupExitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PopupExitButton;
